<template>
  <div v-if="selectedFabric" class="edit uk-container uk-container-xsmall">
    <a @click.prevent="$router.back()" href="#" class="uk-text-uppercase uk-text-meta">
      <span uk-icon="chevron-left"></span>back to fabrics
    </a>
    <h1 class="uk-margin-remove-top uk-article-header uk-text-capitalize">{{ selectedFabric.data.name }} <span
        class="uk-text-meta">{{ mfr_code }} {{ selectedFabric.data.mfr }} {{ selectedFabric.data.brand }} -- Last Updated: {{ new Date(selectedFabric.data.updated_at).toLocaleDateString() }}</span></h1>
    <p class="uk-article-meta"></p>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Fabric Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.name">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Fabric Code</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.mfr_code">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Frankford Code (retired)</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.frankford_code">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Image File Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.image">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Texture File Name</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.texture">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">3D Texture Scale Value <span class="uk-badge"
          id="rangeValue">{{ selectedFabric.data.fabric_scale }}</span></label>
      <div class="uk-form-controls">
        <input v-model="selectedFabric.data.fabric_scale" id="range" class="uk-range uk-width-1-1" type="range" min="0"
          max="5" step=".01" oninput="document.getElementById('rangeValue').innerHTML = this.value">
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Grade</label>
      <div class="uk-form-controls">
        <select class="uk-select" id="form-stacked-select" v-model="selectedFabric.data.grade">
          <option></option>
          <option value="a">Grade A</option>
          <option value="ap">Grade A+</option>
          <option value="b">Grade B</option>
          <option value="c">Grade C</option>
          <option value="d">Grade D</option>
          <option value="e">Grade E</option>
          <option value="f">Grade F</option>
        </select>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Manufacturer</label>
      <div class="uk-form-controls">
        <select class="uk-select" id="form-stacked-select" v-model="selectedFabric.data.mfr_handle">
          <option></option>
          <option value="recasens">Recasens</option>
          <option value="sunbrella">Sunbrella</option>
          <option value="outdura">Outdura</option>
          <option value="tempotest">Tempotest</option>
        </select>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Brand Collection</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.brand_collection">
      </div>
    </div>
    <div class="uk-margin">
      <img :src="'https://frankford.b-cdn.net/fabric_swatches/' + selectedFabric.data.image" width="200" height="200" />
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Color Groups</label>
      <div class="uk-form-controls" uk-grid>
        <label v-for="color in colorGroups" :key="color.name" class="uk-text-capitalize">
          <input name="color_group" class="uk-checkbox" type="checkbox" :value="color.name"
            :checked="inArray(color.name, selectedFabric.data.color_group)" />
          {{ color.name }}</label>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Pattern Groups</label>
      <div class="uk-form-controls" uk-grid>
        <label v-for="pattern in patternGroups" :key="pattern.name" class="uk-text-capitalize">
          <input name="pattern_group" class="uk-checkbox" type="checkbox" :value="pattern.name"
            :checked="inArray(pattern.name, selectedFabric.data.pattern_group)" />
          {{ pattern.name }}</label>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Fabric Equivalents</label>
      <div class="uk-form-controls uk-flex uk-flex-middle" uk-grid>
        <div v-for="fabric in selectedFabric.data.equivalents" :key="fabric" class="uk-text-capitalize">
          <input class="uk-input" name="fabric_equiv" type="text" :value="fabric" />
        </div>
        <a class="" uk-tooltip="Add a new equivalent" uk-icon="plus-circle" @click="selectedFabric.data.equivalents.push('')"></a>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-select">Retired Names</label>
      <div class="uk-form-controls uk-flex uk-flex-middle" uk-grid>
        <div v-for="name in selectedFabric.data.retired_names" :key="name" class="uk-text-capitalize">
          <input class="uk-input" name="retired_names" type="text" :value="name" />
        </div>
        <a class="" uk-tooltip="Add a retired fabric name" uk-icon="plus-circle" @click="selectedFabric.data.retired_names.push('')"></a>
      </div>
    </div>
    <div class="uk-margin">
      <label class="uk-form-label" for="form-stacked-text">Pantone Equivalent</label>
      <div class="uk-form-controls">
        <input class="uk-input" id="form-stacked-text" type="text" v-model="selectedFabric.data.pantone">
      </div>
    </div>
    <div class="uk-button-group">
      <button @click="updateFabric" class="uk-button uk-button-primary">Save</button>
      <div class="uk-inline">
        <button class="uk-button uk-button-default" type="button" aria-label="Toggle Dropdown">
          <span uk-icon="icon: triangle-down"></span>
        </button>
        <div uk-dropdown="mode: click; target: !.uk-button-group;">
          <ul class="uk-nav uk-dropdown-nav">
            <li><a href="#">Save As New</a></li>
            <li><a @click="deleteFabric">Delete</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import UIkit from "uikit";
import axios from "axios";
axios.defaults.headers.apikey = process.env.VUE_APP_API_KEY;

@Component({
  components: {
    // HelloWorld,
  }

})
export default class EditView extends Vue {
  @Prop() private code!: string;
  protected selectedFabric: any | null = null;
  protected mfr_code: string | null = null;
  protected id: string | null = null;
  protected checkedColors = [];
  protected colorGroups = [
    { name: 'Beige' },
    { name: 'Black' },
    { name: 'Blue' },
    { name: 'Brown' },
    { name: 'Gold' },
    { name: 'Grey' },
    { name: 'Green' },
    { name: 'Ivory' },
    { name: 'Orange' },
    { name: 'Pink' },
    { name: 'Purple' },
    { name: 'Red' },
    { name: 'Turquoise' },
    { name: 'White' },
    { name: 'Yellow' },
  ];
  protected patternGroups = [
    { name: 'Solids' },
    { name: 'Stripes' },
    { name: 'Textures' },
    { name: 'Geometrics' },
    { name: 'Tweeds' },
    { name: 'Organic' },
  ];

  async created() {
    this.mfr_code = this.code ?? this.$route.query.code as string ?? undefined;
    if (this.mfr_code) await this.getFabric();
  }

  public async getFabric(): Promise<void> {
    let url = process.env.VUE_APP_API_NODE_URL + "/fabrics/" + this.mfr_code;
    axios.get(url).then((result) => {
      this.selectedFabric = result.data;
    })
  }

  public inArray(needle: string, haystack: []) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
      if (haystack[i] == needle) return true;
    }
    return false;
  }

  public async updateFabric(): Promise<void> {
    let url = process.env.VUE_APP_API_NODE_URL + "/fabrics/update/" + this.selectedFabric.data._id;

    // Set array values and replace originals
    this.selectedFabric.data.color_group = Array.from(document.querySelectorAll("input[name='color_group']:checked")).map((elem: any) => elem.value)
    this.selectedFabric.data.pattern_group = Array.from(document.querySelectorAll("input[name='pattern_group']:checked")).map((elem: any) => elem.value)
    this.selectedFabric.data.equivalents = Array.from(document.querySelectorAll("input[name='fabric_equiv']")).map((elem: any) => elem.value)
    this.selectedFabric.data.retired_names = Array.from(document.querySelectorAll("input[name='retired_names']")).map((elem: any) => elem.value)

    // Set field handles
    this.selectedFabric.data.mfr_handle = (this.selectedFabric.data.mfr).toLowerCase();
    this.selectedFabric.data.brand_handle = (this.selectedFabric.data.brand).toLowerCase();
    if (this.selectedFabric.data.brand_collection) {
      this.selectedFabric.data.brand_collection_handle = (this.selectedFabric.data.brand_collection).toLowerCase();
    }
    
    try {
      axios.put(url, this.selectedFabric.data).then((result) => {
        console.log(result.data)
        if (result.data.status == "success") {
          UIkit.notification({
            message: this.selectedFabric.data.name + " (" + this.selectedFabric.data.mfr_code + ") was updated",
            status: "success"
          });
        }
      })
    } catch (err) {
      UIkit.notification({
        message: "There was a problem saving this fabric - " + err,
        status: "warning"
      });
    }
  }

  public async deleteFabric(): Promise<void> {
    let url = process.env.VUE_APP_API_NODE_URL + "/fabrics/delete/" + this.selectedFabric.data._id;
    try {
      axios.delete(url).then((result) => {
        console.log(result) //TODO: Put in an alert that the swatch was deleted
        if (result.data.status == "deleted") {
          this.$router.push({ name: 'fabrics' })
          UIkit.notification({
            message: this.selectedFabric.data.name + " (" + this.selectedFabric.data.mfr_code + ") was deleted",
            status: "danger"
          });
        }
      })

    } catch (err) {
      console.log(err);
    }

  }
}
</script>

<style scoped>
.uk-grid-margin {
  margin-top: 0px !important;
}
</style>